import FootballGameContextSnapshot from "./football-game-context-snapshot";

/***
 This class is used to store the resulting context at the end of a football play.
 ***/
export default class FootballPlayEndContextSnapshot extends FootballGameContextSnapshot {
    constructor(contextSnapshot) {
        super(contextSnapshot);
        this.kickedBy = null;
        this.currentPeriod = null;
        this.playerInPossession = null;
    }
}
